<template>
    <el-dropdown trigger="click">
        <span class="el-dropdown-link">
            <div>
                <i class="iconfont iconzaixian fxn-text-red" v-if="SipStatus == '2'"></i>
                <i class="iconfont iconzaixian fxn-text-yellow" v-if="SipStatus == '1'"></i>
                {{SipStatus == '1' ? '置闲' : '置忙'}}<i class="el-icon-arrow-down el-icon--right"></i>
            </div>            
        </span>
        <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item class="fxn-text-green" icon=" iconfont iconzaixian" @click.native="updateStatus(1)">签入</el-dropdown-item>
            <el-dropdown-item class="fxn-text-gray" icon=" iconfont iconlixian" @click.native="updateStatus(2)">签出</el-dropdown-item> -->
            <el-dropdown-item class="fxn-text-red" icon=" iconfont iconmangzhi" @click.native="updateStatus(2)">置忙</el-dropdown-item>
            <el-dropdown-item class="fxn-text-yellow" icon=" iconfont iconxianzhi" @click.native="updateStatus(1)">置闲</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    let ws = '';
    export default {
        props: {
            SipStatus: {
                type: [String, Number]
            },
            SipType: {
                type: Boolean
            },
            voipaccount: {
                type: String
            },
            currentSeat: {
                type: Object,
                default: () => null
            }
        },
        computed: {
            isseatcalling() {
                return this.$store.getters.iscalling || this.$store.getters.isincall
            }
        },
        watch: {
            isseatcalling(val, oldval) {
                if (val) { //当坐席拨打 置忙预测式外呼坐席
                    // let arr = ['', '置闲', '置忙'];
                    // this.oldStatus = arr.indexOf(this.SipStatus.status);
                    // this.post('/ycapi/agent/agent_status_update',{
                    //     type: 3
                    // }).then(res => {})
                    this.updateStatus(2, true)
                } else {
                    // if (oldval !== null) {
                    //     let arr = ['', '置闲', '置忙'];
                    //     let status = arr.indexOf(this.SipStatus.status)
                    //     this.post('/ycapi/agent/agent_status_update',{
                    //         type: status === -1 ? this.oldStatus :  status
                    //     }).then(res => {})
                    // }
                    if(this.SipStatus == 2){
                        this.updateStatus(1, true)
                    }
                }
            }
        },
        data(){
            return{
                oldStatus: '',
                seats: []
            }
        },
        methods:{
            //修改坐席状态
            updateStatus(type, isUpdateStatus = false) {
                if (!this.currentSeat || this.currentSeat.link_type != 2) {
                    return
                }

                this.post('/osapi/Intelligence/setSeatState', {
                    voipaccount: this.currentSeat.voipaccount,
                    state: type
                })
                .then(res=> {
                    let{ msg, code, data } = res.data
                    if( code !== 1 ){
                        if( code == 1002 ){
                            this.$message({
                                message: msg,
                                type: 'warning'
                            });
                        }else{
                            this.$message({
                                message: msg,
                                type: 'error'
                            });
                        }
                        return false;
                    } else {
                        if(!isUpdateStatus){
                            this.$message({
                                message: '操作成功!',
                                type: 'success'
                            });
                        }
                        
                        this.$parent.getSeatStatus()
                    }
                })
            },

            
        },
        mounted(){
            let user = JSON.parse(localStorage.getItem('user'))
            // this.seats = user.memberInfo.seats || []
            if(this.currentSeat && this.currentSeat.link_type == 2){
                this.$parent.getSeatStatus()
            }
        },
        beforeDestroy(){
            this.updateStatus(1)
        }
    }
</script>

<style scoped>
    .fxn-radius{
        width: .5rem;
        height: .5rem;
        border-radius: 50%;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/components/AiSip/CallStatus.vue